import { color } from '@central/ui';

/** GoATMS cube mark with the ADMIN CONSOLE label. */
export function Brand() {
  return (
    <>
      <img src="/apple-touch-icon.png" alt="" width={30} height={30} style={{ display: 'block' }} />
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span style={{ fontWeight: 700, color: color.consoleNavActiveText, fontSize: 15 }}>
          GoATMS Central
        </span>
        <span
          style={{
            fontSize: 10,
            fontWeight: 700,
            letterSpacing: '0.1em',
            color: color.consoleMark,
          }}
        >
          ADMIN CONSOLE
        </span>
      </div>
    </>
  );
}
